"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/AccordionComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AccordionItemComponent = /** @class */ (function (_super) {
    __extends(AccordionItemComponent, _super);
    function AccordionItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccordionItemComponent.prototype.render = function () {
        return react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement("div", { className: "card-header collapsed", id: "heading_" + this.props.UniqueKey, "data-toggle": "collapse", "data-target": "#collapse_" + this.props.UniqueKey, "aria-expanded": "true", "aria-controls": "collapse_" + this.props.UniqueKey },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-11" },
                        react_1.default.createElement("h4", { className: "mb-0" }, this.props.Title)),
                    react_1.default.createElement("div", { className: "col-1 d-flex justify-content-center align-items-center" },
                        react_1.default.createElement("i", { className: "fas fa-lg" })))),
            react_1.default.createElement("div", { id: "collapse_" + this.props.UniqueKey, className: "collapse", "aria-labelledby": "heading_" + this.props.UniqueKey, "data-parent": "#accordion_" + this.props.ParentUniqueKey },
                react_1.default.createElement("div", { className: "card-body", dangerouslySetInnerHTML: { __html: this.props.Content } })));
    };
    return AccordionItemComponent;
}(react_1.default.Component));
exports.default = AccordionItemComponent;
